import React from 'react';

function ErrorFallback({error, resetErrorBoundary}:any) {
    return (
      <div>
        <p>Something went wrong:</p>
        <pre>{error.message}</pre>
        <button onClick={resetErrorBoundary}>Try again</button>
      </div>
    )
  }
  
  function Bomb() {
    return(<button onClick={() => {throw new Error('💥 CABOOM 💥')}}>toggle explode</button>)
  }
  
  function ErrorHandler(props:any) {
    const [explode, setExplode] = React.useState(false)
    return (
      <div>
        {/* <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {}}
        >
          {Bomb()} 
        </ErrorBoundary> */}
      </div> 
    ) 
  }
 
  export default ErrorHandler;